import Modal from "bootstrap/js/dist/modal";

//gallery modal
document.querySelectorAll(".gallery-item").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();
        const fullImg = item.getAttribute("href");
        document.getElementById("modalImage").src = fullImg;
        const modal = new Modal(document.getElementById("galleryModal"));
        modal.show();
    });
});

//close the modal on click
function closeModal() {
    const galleryModalElement = document.getElementById("galleryModal");
    if (!galleryModalElement) {
        return;
    }
    galleryModalElement.addEventListener("click", () => {
        const myModal = Modal.getInstance(galleryModalElement);
        myModal.hide();
    });
}
closeModal();

//gallery page load more
//The hidden items carry their thumbnail URL and alt text on the anchor (data-gallery-src /
//data-gallery-alt) and hold no <img>, so image-optimizer plugins have nothing to rewrite. The
//fallbacks below cover markup produced by the older template, which may still be sitting in a
//plugin's HTML cache: such an <img> has had its data-src consumed and re-published under a
//plugin-private name.
const GALLERY_SRC_ATTRS = [
    "data-src",
    "data-wpc-qw-src",
    "data-wpc-fb",
    "data-lazy-src",
];

function galleryThumbUrl(hiddenItem) {
    const own = hiddenItem.getAttribute("data-gallery-src");
    if (own) {
        return own;
    }
    const img = hiddenItem.querySelector("img");
    if (!img) {
        return null;
    }
    for (const attr of GALLERY_SRC_ATTRS) {
        const value = img.getAttribute(attr);
        if (value) {
            return value;
        }
    }
    //a real src that is not a placeholder is already usable
    const src = img.getAttribute("src");
    return src && src.indexOf("data:") !== 0 ? src : null;
}

document.querySelectorAll("#gallery-load-more").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();

        //get the hidden gallery items
        const hiddenItems = document.querySelectorAll(".gallery-item.d-none");
        if (!hiddenItems.length) {
            return;
        }
        let revealed = 0;
        //loop through the hidden items and show them
        hiddenItems.forEach((hiddenItem) => {
            const thumbUrl = galleryThumbUrl(hiddenItem);
            if (!thumbUrl) {
                return;
            }
            //build the image if the item does not already carry one
            let img = hiddenItem.querySelector("img");
            if (!img) {
                img = document.createElement("img");
                img.alt = hiddenItem.getAttribute("data-gallery-alt") || "";
                hiddenItem.appendChild(img);
            }
            //set the src attribute
            img.src = thumbUrl;
            //remove the hidden class
            hiddenItem.classList.remove("d-none");
            revealed += 1;
        });
        //only retire the button if it actually did something: a silent failure here reads as a
        //caching bug, a button that stays put reads as the bug it is
        if (revealed) {
            item.remove();
        }
    });
});

//accordion
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
    });
}

//modify the functionality of the main menu with dropdowns on desktop
document.querySelectorAll(".navbar-nav a.dropdown-toggle").forEach((item) => {
    item.addEventListener("click", (e) => {
        //prevent propagation
        e.stopPropagation();

        //get the href attribute
        const href = item.getAttribute("href");
        if (href === "#") {
            return;
        }

        //find the element with the class .offcanvas-start in the element's parent tree
        const offcanvasStart = item.closest(".offcanvas-start");
        if (!offcanvasStart) {
            return;
        }

        //check if the offcanvas has the show class
        const isOffcanvasShown = offcanvasStart.classList.contains("show");
        if (isOffcanvasShown) {
            return;
        }

        //go to the href
        window.location.href = href;
    });
});
